export default __webpack_public_path__ + "static/media/logo1.b7d50453.png";